var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-5.08c-.488-3.386-3.401-6-6.92-6V13.191A5.999 5.999 0 0 0 50 8c0-3.309-2.691-6-6-6H28c-2.559 0-4.805 1.643-5.641 4H12c-3.309 0-6 2.691-6 6a5.999 5.999 0 0 0 3 5.191V28c-3.859 0-7 3.141-7 7v22a1 1 0 0 0 1 1h5v1c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3v-1h24v1c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3v-1h5a1 1 0 0 0 1-1V40h5c1.654 0 3-1.346 3-3s-1.346-3-3-3zM28 4h16c2.206 0 4 1.794 4 4a4 4 0 0 1-2.401 3.662 1 1 0 0 0-.599.916V28H31V17.191A5.999 5.999 0 0 0 34 12c0-3.309-2.691-6-6-6h-3.464c.7-1.207 2.01-2 3.464-2zM10.401 15.662A4 4 0 0 1 8 12c0-2.206 1.794-4 4-4h16c2.206 0 4 1.794 4 4a4 4 0 0 1-2.401 3.662 1 1 0 0 0-.599.916V28H11V16.578a1 1 0 0 0-.599-.916zM4 35c0-2.757 2.243-5 5-5h38c2.757 0 5 2.243 5 5v15H4V35zm10 24a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1h4v1zm32 0a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1h4v1zm6-3H4v-4h48v4zm7-18h-5v-2h5a1 1 0 0 1 0 2z",
    fill: "current",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12v-2c-2.206 0-4 1.794-4 4h2c0-1.103.897-2 2-2zM25 24h2v2h-2zM25 20h2v2h-2zM25 16h2v2h-2zM41 13h2v2h-2zM41 17h2v2h-2zM41 21h2v2h-2zM45 39c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM60 2h2v12h-2zM54 6h2v12h-2zM60 16h2v2h-2zM54 20h2v2h-2z",
    fill: "current",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterIcon);
export default __webpack_public_path__ + "static/media/toaster-icon.4a151969f1ab588ae18b629bffae5fa4.svg";
export { ForwardRef as ReactComponent };